/* eslint-disable @typescript-eslint/lines-between-class-members */
enum MessageActivity {
  CreateNewMessage, // client -> server
  NewMessageCreated, // server -> client (upon new message sent from a client)
  MessageCreationError, // server -> client (with the clientMessageId)
  MessageFetched, // server -> client (per every message after a FetchMessages is issued)
  FetchMessages // client -> server
}

export interface MessageEnvelope<T> {
  activity: MessageActivity;
  schemaVersion: number;
  payload: T;
}

export enum MessageType {
  UserJoinedMission = 'user_joined',
  UserLeftMission = 'user_left',
  CropInspectionNeeded = 'crop_inspection_needed',
  Freetext = 'chat',
  AssumeLiveViewControls = 'assume_live_view_controls',
  ReleaseLiveViewControls = 'release_live_view_controls'
}

export enum MessageStatus {
  Pending = 'Pending',
  Confirmed = 'Confirmed',
  Failed = 'Failed'
}

export interface MessageBase {
  messageId?: string; // Unique ID assigned by backend
  clientMessageId?: string; // Client assigned temporary ID
  user?: {
    id: string; // The user joined/left/created the message
    initials: string;
    userName: string;
  }
  messageType: MessageType;
  messageStatus?: MessageStatus;
  timeStamp: string;
}

export interface TextMessage extends MessageBase {
  text: string;
}

export type Location = {
  longitudeDeg: number;
  latitudeDeg: number;
}

export interface TerrainMessage extends MessageBase {
  imageId: string;
  imageServerURL: string;
  imageClientURL?: string;
  text: string;
}
